import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	address: {
		marginBottom: theme.spacing(5)
	},
	title: {
		marginBottom: theme.spacing(2)
	},
	content: {
		margin: theme.spacing(0, 0, 4),
		"& p": {
			marginBottom: 2
		},
		"& a": {
			fontWeight: 400,
			"&:hover": {
				textDecoration: "underline"
			}
		}
	}
}));

export default styles;
